module.exports = __webpack_public_path__ + "img/47.zone_is_dirty.dc16d4c4.svg";